// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

// eslint-disable-next-line no-unused-vars
import { PayType } from "@/enums/payType";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## PaymentSetting Get
/**
 *
 * @param {{params: object, query: { payType: PayType }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.PaymentSetting.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## PaymentSetting Create
/**
 *
 * @param {{"payType": "WithKdv","value": number}} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.PaymentSetting.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## PaymentSetting Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.PaymentSetting.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## PaymentSetting Update
/**
 *
 * @param {{"payType": "WithKdv","value": number, isActive: boolean}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(
    Endpoints.PaymentSetting.Update(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## PaymentSetting Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.PaymentSetting.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
